import Vue from 'vue';
import VueRouter from 'vue-router';
import adminRoutes from './admin';
import guestRoutes from './guest';
import personRoutes from './person';
import superUserRoutes from './superUser';
import { loginWith, loggedIn, getUser } from '@/plugins/auth';
import { verifyCompany } from './companies';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		redirect: { name: 'activities' },
	},
	{
		path: '*',
		name: 'Error',
		component: require('@/views/404').default, // load sync
		meta: { layout: 'simple' },
	},
].concat(adminRoutes, guestRoutes, personRoutes, superUserRoutes);

const router = new VueRouter({
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
});

router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (loggedIn()) {
			const moveToCompany = verifyCompany();
			if (moveToCompany) window.location.href = moveToCompany;
			const role = getUser().role;
			// is super user
			if (to.matched.some(record => record.meta.isSuperUser) && role == 'superUser') {
				next();
			}
			// is admin
			else if (to.matched.some(record => record.meta.isAdmin) && role == 'admin') {
				next();
			}
			// is person
			else if (to.matched.some(record => record.meta.isPerson) && role == 'person') {
				next();
			} else {
				if (role == 'admin' || role == 'superUser') next({ name: 'inicio' });
				else next({ name: 'account-guest', path: '/guest/account' });
			}
		} else {
			next({
				path: '/auth',
				params: { nextUrl: to.fullPath },
			});
		}
	} else {
		if (!loggedIn() && to.query.token && to.name !== 'passwordReset') {
			await loginWith('google-after-login', {
				token: to.query.token,
				refreshToken: to.query.refreshToken,
			});
			next({ name: 'inicio' });
		}
		next();
	}
});

export default router;
